import React, { RefObject } from "react"

const VisibleContext = React.createContext(false)

export function ProvideVisibility<T extends HTMLElement>(props: {
  element: RefObject<T>
  threshold?: number
  children: React.ReactNode
}) {
  const visible = useIsVisible(props.element, props.threshold)
  return <VisibleContext.Provider value={visible}>{props.children}</VisibleContext.Provider>
}

export function useNearestVisibility() {
  return React.useContext(VisibleContext)
}

export function useIsVisible<T extends HTMLElement>(element: RefObject<T>, threshold = 0.01) {
  const [ visible, setVisible ] = React.useState(false)

  React.useEffect(() => {
    if (!element.current) return
    const observer = new IntersectionObserver(
      ([ entry ]) => {
        setVisible(entry.isIntersecting)
      }, { threshold }
    )
    observer.observe(element.current)
    return () => observer.disconnect()
  }, [ element, setVisible, threshold ])

  return visible
}
